
import {StrategyBaseClass} from './strategy-base-class.js'


export class TrustpilotService extends StrategyBaseClass {
  constructor($translate) {
    super($translate);
  }

  getType() {
    return 15;
  }
  getTypeString() {
    return 'trustpilot';
  }
  getAllTasksTypes() {
    return [40, 41];
  }
  getPublicTaskTypes() { 
    return [40];
  }
  getPrivateTaskTypes() {
    return [41];
  }
  getTaskTypeString(taskType) {
    let mapping = {
      40 : 'trustpilot/service-review',
      41 : 'trustpilot/product-review'
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType) {
    let mapping = {
      40 : 'trustpilot-service-review',
      41 : 'trustpilot-product-review'
    };
    return mapping[taskType];
  }

  canHaveSurveys() {
    return false;
  }

  getEditorConfiguration(isPrivate) {
    return {
      'pictureEnabled': false
    };
  }

  static TrustpilotFactory($translate) {
    return new TrustpilotService($translate);
  }
}
TrustpilotService.TrustpilotFactory.$inject = ['$translate'];
